import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { IntroductionComponent } from '../introduction/introduction.component';

@NgModule({
	declarations: [
		IntroductionComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		IonicModule
	],
	exports: [
		IntroductionComponent,
	]
})
export class IntroductionModule { }
